<!-- @format -->
<template>
  <div class="main-div">
    <message-box ref="msgbox"></message-box>
    <login-form v-if="$store.state.isAuthenticated == false"></login-form>
  </div>
</template>
<script>
import LoginForm from "@/components/LoginForm.vue";
// import axios from "axios";

export default {
  components: {
    LoginForm,
  },
  data() {
    return {
      setupdone: false,
      outletcode: "",
      serverURL: this.$store.state.serverPath,
      isSettingup: false,
      tdmId: this.$store.state.tdmId,
    };
  },
  methods: {},
  mounted() {
    // var host = window.location.protocol + "//" + window.location.host;
    // console.log("Host:" + host);
  },
};
</script>
<style>
@import "../css/formcontrol.css";
</style>
